// eslint-disable-next-line no-shadow
enum ETipoComprovanteExtrato {
  TRANSFERENCIA_P2P = 'transferenciaP2P',
  TRANSFERENCIA_TED = 'transferenciaTED',
  TRANSACAO_PAGAMENTO = 'transacaoPagamento',
  RECARGA_CELULAR = 'recargaCelular',
  EXTRACAO_DADO = 'extracaoDado',
}

export const TipoComprovanteExtrato: {
  [key in ETipoComprovanteExtrato]: string
} = {
  [ETipoComprovanteExtrato.TRANSFERENCIA_P2P]: 'Comprovante de transferência',
  [ETipoComprovanteExtrato.TRANSFERENCIA_TED]: 'Comprovante de transferência',
  [ETipoComprovanteExtrato.TRANSACAO_PAGAMENTO]: 'Comprovante de boleto',
  [ETipoComprovanteExtrato.RECARGA_CELULAR]: 'Comprovante de recarga',
  [ETipoComprovanteExtrato.EXTRACAO_DADO]: 'Extrato',
}

export default ETipoComprovanteExtrato
